import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FlexStack } from '~/components/atomic';
import { CharacterCard } from '~/components/atomic/Skeleton';
import { makeIndexArray } from '~/utils';

export default function MoreOneOnOneSkeleton() {
  return (
    <Container>
      <CardWrapper>
        {makeIndexArray(6).map((el) => (
          <CharacterCard key={el} width={150} />
        ))}
      </CardWrapper>

      <ExploreWrapper>
        {makeIndexArray(6).map((el) => (
          <CharacterCard key={el} />
        ))}
      </ExploreWrapper>
    </Container>
  );
}

const Container = styled(FlexStack)`
  ${({ theme }) => css`
    gap: 54px;
    padding-top: calc(54px + ${theme.layout.chat_header_height});
    padding-bottom: ${theme.layout.chat_navigation_height};
  `}
`;

const CardWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  padding-left: 16px;
  overflow-x: hidden;
  gap: 8px;
`;

const ExploreWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 16px;
    ${theme.mediaQuery.mobile_480} {
      grid-template-columns: 1fr 1fr;
    }
  `}
`;
